








































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import LogoSelector from '@ui/LogoSelector'
import TreeSelector from '@ui/TreeSelector'

settings =
  name: 'BrandInfoStep'

  vue:
    props: ['wizard']
    store: ['member']
    mixins: [WizardService.step()]
    components: { LogoSelector, TreeSelector }

    data: ->
      brandCategories: []
      otherBrandCategory: ''
      extraBrandCategories: []
      galleryFilesToUpload: []

    mounted: ->
      @initializeBrand()

    computed:
      brand: -> @wizard.campaignData.brand_info || {}
      existingBrands: -> @wizard.org?.brands || []
      brandCategoriesOptions: ->
        mapping = @marketplace?.brand?.categories || {}
        tree = @marketplace?.brand?.category_tree || {}
        tree.other ||= "Other" # auto add as a top level category
        @jsonToElementUICascader tree, mapping
      brandCategoriesActions: ->
        select: @selectBrandCategories

      guessDomainName: ->
        guess = @member?.email?.split('@')[1] if not @brand?.id?
        guess = @wizard.partnerBuy.brandRep.email.split('@')[1] if @wizard.partnerBuy?.brandRep
        guess

      galleryImages: -> image.url for image in @ctxImages(@wizard.campaignData)
      brandLogoURL: -> @wizard.brandData.logo_url
      logoUploadPath: -> "#{process.env.VUE_APP_API_ENDPOINT}/uploads/brands/#{@brandId}/logo"
      photoUploadPath: -> "#{process.env.VUE_APP_API_ENDPOINT}/uploads/campaigns/#{@wizard.campaignData.id}/promotable_photo"

    methods:
      validateStep: ->
        @validateBrandName()
        @validateCategory()

      validateBrandName: ->
        unless @brand.name and !!"#{@brand.name}".trim().length
          @wizard.setFormError 'brand_name', 'Enter a brand name'
          @wizard.setModelError 'brand_name', 'Please, enter a brand name'

      validateCategory: ->
        @validateOtherCategory()

        categoryIsSelected = !!@brandCategories.length
        unless categoryIsSelected
          @wizard.setFormError 'brand_categories', 'Select a category'
          @wizard.setModelError 'brand_categories', 'Please, select a brand category'

      validateOtherCategory: ->
        otherIsSelected = @brandCategories.includes('other')
        if otherIsSelected and !@extraBrandCategories.length
          @wizard.setFormError 'other_brand_category', 'Enter a brand category'
          @wizard.setModelError 'other_brand_category', 'Please, enter brand category name'

      initializeBrand: ->
        @initializeBrandCategories()

      initializeBrandCategories: ->
        @wizard.clearError(['brand_categories', 'other_brand_category'])
        categories = []
        extraCategories = []

        obj = @marketplace?.brand?.category_tree
        { category_tags } = @wizard.campaignData.brand_info

        for category, index in (category_tags || [])
          isExtra = !Object.keys(obj).includes(category)

          if category is 'other'
            obj = 'Other'
            categories.push category
          else if isExtra
            extraCategories.push category
          else
            obj = obj[category]
            categories.push category

        @brandCategories = categories
        @extraBrandCategories = extraCategories

      hiSelectBrand: (brand) ->
        @wizard.clearError('brand_name')
        @wizard.campaignData.brand_info[k]=v for k,v of (brand || {})

      changeBrandCategories: (categories) ->
        @brandCategories = categories
        @wizard.clearError('brand_categories')
        @extraBrandCategories = [] unless categories.includes('other')
        @wizard.campaignData.brand_info.category_tags = [...categories, ...@extraBrandCategories]

      selectBrandCategories: (categories) ->
        @brandCategories = categories
        @wizard.clearError('brand_categories')
        @extraBrandCategories = [] unless @brandCategories.includes('other')
        @wizard.campaignData.brand_info.category_tags = [...@brandCategories, ...@extraBrandCategories]

      hiAddOtherBrandCategory: ->
        @extraBrandCategories.push @otherBrandCategory
        @wizard.campaignData.brand_info.category_tags.push @otherBrandCategory
        @otherBrandCategory = ''

      hiRemoveExtraCategory: (name) ->
        @extraBrandCategories = @extraBrandCategories.filter((c) -> c isnt name)
        @wizard.campaignData.brand_info.category_tags = @wizard.campaignData.brand_info.category_tags.filter((c) -> c isnt name)

      hiOtherBrandCategoryFocus: ->
        @wizard.clearError('other_brand_category')

      hiPhotoUploadRemove: (file) -> console.log(file)
      onPhotoUploadChange: (file) -> @wizard.fetchBrand()
      onPhotoUploadPreview:(file)-> @openGalleryImage(index)(0)

export default VueOptions.vue settings
